<template>
    <div>
        <!--Title-->
        <div class="mb-3 text-right col-md-12">
                <h4 class="title center-title pull-left">Reportes</h4>
        </div>
        <!--./Title-->
        <!--Loading state-->
        <loading :active.sync="this.$apollo.queries.regionalsReports.loading"
        :can-cancel="false"
        :is-full-page="fullPage">
        </loading>
        <loading :active.sync="this.$apollo.queries.regionalReports.loading"
        :can-cancel="false"
        :is-full-page="fullPage">
        </loading>
        <loading :active.sync="this.$apollo.queries.officeReports.loading"
        :can-cancel="false"
        :is-full-page="fullPage">
        </loading>
        <!--./Loading state-->
        <!--Sending state-->
        <loading :active.sync="isSending"
        :can-cancel="false"
        :is-full-page="fullPage">
        </loading>
        <!--./Sending state-->
        <!--Empty state-->
        <!--<div v-if="tableData && !tableData.length && !this.$apollo.queries.activityTypes.loading" class="mt-3 col-md-12 card">
        <div class="card-header">
        </div>
        <div class="card-body">
            <img class="no_data_center"  v-bind:src="no_data_image" alt="">
        </div>
        </div>-->
        <!--./Empty state-->
        <!--Filter data-->
        <div class="col-md-12 card">
            <form>
            <div class="card-header">
                <div class="category">Selecciona las fechas</div>
            </div>
            <div class="card-body row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Fecha inicial</label>
                        <el-date-picker
                            v-model="model.startdate"
                            type="datetime"
                            placeholder="Seleccione fecha inicial">
                        </el-date-picker>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Fecha final</label>
                        <el-date-picker
                            v-model="model.enddate"
                            type="datetime"
                            placeholder="Seleccione fecha final">
                        </el-date-picker>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Regional</label>
                        <fg-input
                                    type="text"
                                    name="user"
                                    autocomplete="off"
                                    :error="getError('user')">
                                <el-select @change="resetOffice()"
                                        class="select-warning"
                                        size="large"
                                        placeholder="Seleccione regional..."
                                        v-model="model.regional">
                                <el-option class="select-warning"
                                value=""
                                label="Seleccione">
                                </el-option>
                                <el-option v-for="option in regionals_array"
                                        class="select-warning"
                                        :value="option.id"
                                        :label="option.name"
                                        :key="option.id">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Agencia</label>
                        <fg-input
                                    type="text"
                                    name="user"
                                    autocomplete="off"
                                    :error="getError('user')">
                                <el-select @change="resetUser()"
                                        class="select-warning"
                                        size="large"
                                        placeholder="Seleccione agencia..."
                                        v-model="model.office">
                                <el-option class="select-warning"
                                        value=""
                                        label="Todas">
                                </el-option>
                                <el-option v-for="option in offices_array_computed"
                                        class="select-warning"
                                        :value="option.id"
                                        :label="option.name"
                                        :key="option.id">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                </div>
                <!-- <div class="col-md-6">
                    <div class="form-group">
                        <label>Usuario</label>
                        <fg-input
                                    type="text"
                                    name="user"
                                    autocomplete="off"
                                    :error="getError('user')">
                                <el-select class="select-warning"
                                        size="large"
                                        placeholder="Seleccione usuario..."
                                        v-model="model.user">
                                <el-option class="select-warning"
                                        value=""
                                        label="Todos">
                                </el-option>
                                <el-option v-for="option in users_array_computed"
                                        class="select-warning"
                                        :value="option.id"
                                        :label="option.name+' '+option.surname"
                                        :key="option.id">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                </div> -->
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button v-if="model.startdate != '' && model.enddate != ''" @click="downloadXLS()" class="mr-3" type="primary">Descargar reporte</p-button>
                    <p-button @click.prevent="validate" type="success">Aceptar</p-button>
                    <p-button @click="cancelForm()" type="default" class="pull-left">Cancelar</p-button>
                </div>
            </div>
            </form>
        </div>
        <!--/Filter data-->
        <!--Stats cards-->
        <card v-if="viewReports">
            <template slot="header">
            <h4 class="card-title">Reportes</h4>
            <p class="category">Por estado (Finalizados, en trámite)</p>
            </template>
            <bar-chart :labels="statusChart.labels"
                    :height="250"
                    :extra-options="statusChart.options"
                    :datasets="statusChart.datasets">
            </bar-chart>
        </card>
        <card v-if="viewReports">
            <template slot="header">
            <h4 class="card-title">Reportes</h4>
            <p class="category">Tiempos promedio (minutos)</p>
            </template>
            <bar-chart :labels="averageChart.labels"
                    :height="250"
                    :extra-options="averageChart.options"
                    :datasets="averageChart.datasets">
            </bar-chart>
        </card>
        <card v-if="viewReports">
            <template slot="header">
            <h4 class="card-title">Reportes</h4>
            <p class="category">Por tipo de actividad (Comercio, producción, servicios)</p>
            </template>
            <bar-chart :labels="activityChart.labels"
                    :height="250"
                    :extra-options="activityChart.options"
                    :datasets="activityChart.datasets">
            </bar-chart>
        </card>
        <!-- <div v-if="viewReports" class="row">
            <div class="col-md-6">
                <stats-card type="success"
                            icon="nc-icon nc-cloud-upload-94"
                            small-title="Evaluaciones finalizadas"
                            :title="finishedAssessmentsCount">
                <div class="stats" slot="footer">
                    <i class="nc-icon nc-refresh-69"></i>
                    {{reportTime | reportTimeMethod}}
                </div>
                </stats-card>
            </div>
            <div class="col-md-6">
                <stats-card type="warning"
                            icon="nc-icon nc-cloud-download-93"
                            small-title="Evaluaciones en trámite"
                            :title="inProcessAssessmentsCount">
                <div class="stats" slot="footer">
                    <i class="nc-icon nc-refresh-69"></i>
                    {{reportTime | reportTimeMethod}}
                </div>
                </stats-card>
            </div>
        </div> -->
        <!--<div class="row">
            <div class="col-md-6">
                <circle-chart-card :percentage="70"
                                chart-id="email-statistics-chart"
                                title="Evaluaciones finalizadas"
                                color="#6bd098">
                </circle-chart-card>
        </div>
        <div class="col-md-6">
                <circle-chart-card :percentage="70"
                                chart-id="email-statistics-chart"
                                title="Evaluaciones en trámite"
                                color="#fbc658">
                </circle-chart-card>
        </div>-->
        <!-- <div v-if="viewReports" class="col-md-12">
                <card>
                    <template slot="header">
                    <h4 class="card-title">Histórico</h4>
                    <p class="category">Resultados de los últimos 6 meses</p>
                    </template>
                    <line-chart :labels="stockChart.labels"
                                :height="250"
                                :color="stockChart.color"
                                :extra-options="stockChart.options"
                                :datasets="stockChart.datasets">
                    </line-chart>
                </card>
        </div>    -->
    </div>

</template>
<script>
    import swal from 'sweetalert2'
    import Vue from 'vue'
    import {Table, TableColumn, Select, Option, DatePicker, TimeSelect, Button} from 'element-ui'
    import { TimeLine, TimeLineItem } from 'src/components/UIComponents'
    import PPagination from 'src/components/UIComponents/Pagination.vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { Tooltip } from 'element-ui'
    import gql from 'graphql-tag'
    import { regionals } from 'src/api/graphql/queries/setup/AllRegionals';
    import { offices } from 'src/api/graphql/queries/setup/AllOffices';
    import { users } from 'src/api/graphql/queries/user/AllUsers';
    import { activityTypes } from 'src/api/graphql/queries/setup/AllActivityTypes';
    import { regionalsReports } from 'src/api/graphql/queries/reports/AllRegionals';
    import { regionalReports } from 'src/api/graphql/queries/reports/Regional';
    import { officeReports } from 'src/api/graphql/queries/reports/Office';
    import { assessmentsReport } from 'src/api/graphql/queries/reports/AllReports';
    import { monthlyReport } from 'src/api/graphql/queries/reports/HistoricalReport';
    import { CREATE_ACTIVITY_TYPE } from 'src/api/graphql/mutations/setup/AddEditActivityTypes';
    import { orderBy , sortBy , find } from 'lodash';
    import SecureLS from 'secure-ls';
    import { REFRESH_TOKEN } from 'src/api/graphql/mutations/auth/RefreshToken';
    import { VERIFY_TOKEN } from 'src/api/graphql/mutations/auth/VerifyToken';
    import BarChart from 'src/components/UIComponents/Charts/BarChart'
    import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
    import moment from 'moment'
    import axios from 'axios'

    import StatsCard from 'src/components/UIComponents/Cards/StatsCard';
    import LineChart from 'src/components/UIComponents/Charts/LineChart'
    const tooltipOptions = {
        tooltipFillColor: "rgba(0,0,0,0.5)",
        tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        tooltipFontSize: 14,
        tooltipFontStyle: "normal",
        tooltipFontColor: "#fff",
        tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        tooltipTitleFontSize: 14,
        tooltipTitleFontStyle: "bold",
        tooltipTitleFontColor: "#fff",
        tooltipYPadding: 6,
        tooltipXPadding: 6,
        tooltipCaretSize: 8,
        tooltipCornerRadius: 6,
        tooltipXOffset: 10,
    };
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default{
        /***
        * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
        *
        **/
        apollo:{
        regionalsReports: {
                query: regionalsReports,
                variables() {
                    return {
                        isActive: true,
                        reportStartDate: this.startdate_fetch,
                        reportEndDate: this.enddate_fetch
                    }
                },
                skip() {
                    return this.skipRegionalsReports
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {
                    if(data.regionalsReports.edges.length == 0)
                    {
                        this.showNotificationError('No hay evaluaciones registradas');
                    }
                    else
                    {
                        this.setRegionalsReportsFullData(data.regionalsReports);
                        this.skipRegionalsReports = true;
                    }
                },
                // Si encontró algún error.
                error(error) {

                },
            },
        regionalReports: {
                query: regionalReports,
                variables() {
                    return {
                        id: this.regional_fetch,
                        reportStartDate: this.startdate_fetch,
                        reportEndDate: this.enddate_fetch
                    }
                },
                skip() {
                    return this.skipRegionalReports
                },
                fetchPolicy: 'network-only',
                result({ data, loading, networkStatus }) {
                    console.info(data);
                    if(data.regionalReports == null)
                    {
                        this.showNotificationError('No hay evaluaciones registradas');
                    }
                    else
                    {
                        this.setRegionalReportsFullData(data.regionalReports);
                        this.skipRegionalReports = true;
                    }
                },
                // Si encontró algún error.
                error(error) {

                },
            },
        officeReports: {
                query: officeReports,
                variables() {
                    return {
                        id: this.office_fetch,
                        reportStartDate: this.startdate_fetch,
                        reportEndDate: this.enddate_fetch
                    }
                },
                skip() {
                    return this.skipOfficeReports
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {
                    if(data.officeReports == null)
                    {
                        this.showNotificationError('No hay evaluaciones registradas');
                    }
                    else
                    {
                        this.setOfficeReportsFullData(data.officeReports);
                        this.skipOfficeReports = true;
                    }
                },
                // Si encontró algún error.
                error(error) {

                },
            },
        activityTypes: {
                    query: activityTypes,
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {

                        if(data.activityTypes.edges.length == 0)
                        {
                            this.activityTypes_array = [];
                        }
                        else
                        {
                            this.setActivityTypes(data.activityTypes);
                            this.$apollo.queries.activityTypes.skip = true;
                        }

                    },
                    // Si encontró algún error.
                    error(error) {

                    },
                },
        // users:    {
        //             query: users,
        //             skip: false,
        //             fetchPolicy: 'network-only',
        //             // Si tenemos un resultado, pero no encontró el slug.
        //             result({ data, loading, networkStatus }) {
        //                 if(data.users.edges.length == 0)
        //                 {
        //                     this.users = [];
        //                 }
        //                 else
        //                 {
        //                     this.setUsers(data.users);
        //                     this.$apollo.queries.users.skip = true;
        //                 }

        //             },
        //             // Si encontró algún error.
        //             error(error) {

        //             },
        //         },
        offices:{
                    query: offices,
                    variables:{
                        isActive: true
                    },
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {

                        if(data.offices.edges.length == 0)
                        {
                            this.offices = [];
                        }
                        else
                        {
                            this.setOffices(data.offices);
                            this.$apollo.queries.offices.skip = true;
                        }

                    },
                    // Si encontró algún error.
                    error(error) {

                    },
                },
        regionals: {
                query: regionals,
                skip: false,
                variables: {
                    isActive: true
                },
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {

                    if(data.regionals.edges.length == 0)
                    {
                        this.regionals_array = [];
                    }
                    else
                    {
                        this.setRegionals(data.regionals);
                        this.$apollo.queries.regionals.skip = true;
                    }

                },
                // Si encontró algún error.
                error(error) {

                },
            },
        },
        components: {
        TimeLine,
        TimeLineItem,
        PPagination,
        Loading,
        [Tooltip.name]: Tooltip,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Button.name]: Button,
        StatsCard,
        LineChart,
        CircleChartCard,
        BarChart,
        },
        computed: {
        offices_array_computed(){
            return this.offices_array.filter(i => i.regional == this.model.regional)
        },
        users_array_computed(){
            return this.users_array.filter(i => i.office == this.model.office)
        },
        pagedData () {
            return this.tableData.slice(this.from, this.to)
        },
        /***
        * Searches through table data and returns a paginated array.
        * Note that this should not be used for table with a lot of data as it might be slow!
        * Do the search and the pagination on the server and display the data retrieved from server instead.
        * @returns {computed.pagedData}
        */
        queriedData () {
            if (!this.searchQuery) {
            this.pagination.total = this.tableData.length
            return this.pagedData
            }
            let result = this.tableData
            .filter((row) => {
                let isIncluded = false
                for (let key of this.propsToSearch) {
                let rowValue = row[key].toString().toLowerCase();
                if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                    isIncluded = true
                }
                }
                return isIncluded
            })
            this.pagination.total = result.length
            return result.slice(this.from, this.to)
        },
        to () {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
            highBound = this.total
            }
            return highBound
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total () {
            this.pagination.total = this.tableData.length
            return this.tableData.length
        }
        },
        data () {
        return {
            inProcessAssessmentsCount: '0',
            finishedAssessmentsCount: '0',
            no_data_image : process.env.VUE_APP_BASE_ROUTE+'img/no_data.png',
            isSending: false,
            fullPage: false,
            viewReports: false,
            tableData: [],
            regionals_array: [],
            offices_array : [],
            users_array: [],
            analyst_fetch: null,
            office_fetch: null,
            regional_fetch: null,
            startdate_fetch: null,
            enddate_fetch: null,
            created_at_fetch: null,
            created_at_end_fetch: null,
            skipAssessments: true,
            skipRegionalsReports: true,
            skipRegionalReports: true,
            skipOfficeReports: true,
            assessmentsReportArray: [],
            activityTypes_array : [],
            reportTime: null,
            interval: null,
            addActivityType : false,//Bandera de creación de tipo de actividad
            editActivityType : false,//Bandera de edición de tipo de actividad
            rowEdit: {},
            formName: 'Cargando...',//Nombre del formulario de creación/edición
            model: {
                startdate: '',
                enddate: '',
                user: '',
                regional: '',
                office: '',
                status: '',
            },
            assessments: [
                {
                    code: '101765654',
                    name: 'Carlos Ordoñez',
                    status: 'Finalizado',
                    date: '12/02/2020',
                    hour: '5:45 P.M',
                    assessment: '1',
                    analyst: 'Deiro Solarte',
                },
                {
                    code: '101765654',
                    name: 'Carlos Ordoñez',
                    status: 'En trámite',
                    date: '12/02/2020',
                    hour: '5:45 P.M',
                    assessment: '2',
                    analyst: 'Deiro Solarte',
                },
                {
                    code: '101765654',
                    name: 'Carlos Ordoñez',
                    status: 'Finalizado',
                    date: '12/02/2020',
                    hour: '5:45 P.M',
                    assessment: '3',
                    analyst: 'Deiro Solarte',
                },
                {
                    code: '101765654',
                    name: 'Carlos Ordoñez',
                    status: 'Finalizado',
                    date: '12/02/2020',
                    hour: '5:45 P.M',
                    assessment: '4',
                    analyst: 'Deiro Solarte',
                }
            ],
            modelValidations: {
            code: {
                required: true,
                numeric: true,
                max: 8
            },
            name: {
                required: true,
                max: 32
            },
            },
            pagination: {
            perPage: 5,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0
            },
            searchQuery: '',
            propsToSearch: ['code', 'name'],
            tableColumns: [
            {
                prop: 'code',
                label: 'Número de cédula',
                minWidth: 200
            },
            {
                prop: 'name',
                label: 'Nombre cliente',
                minWidth: 250
            },
            {
                prop: 'status',
                label: 'Estado',
                minWidth: 250
            },
            {
                prop: 'date',
                label: 'Fecha',
                minWidth: 250
            },
            {
                prop: 'hour',
                label: 'Hora',
                minWidth: 250
            },
            {
                prop: 'assessment',
                label: 'Número solicitud',
                minWidth: 250
            },
            {
                prop: 'analyst',
                label: 'Analista',
                minWidth: 250
            },
            ],
        stockChart: {
            labels: ["Mes", "Mes", "Mes", "Mes", "Mes", "Mes"],
            datasets: [{
                label: "Ev. Finalizadas",
                borderColor: "#6bd098",
                pointBackgroundColor: "#6bd098",
                pointRadius: 3,
                pointHoverRadius: 3,
                lineTension: 0,
                fill: false,
                borderWidth: 3,
                data: [0, 0, 0, 0, 0, 0, 0]
        },
        {
        label: "Ev. en trámite",
        borderColor: "#fbc658",
        pointBackgroundColor: "#fbc658",
        pointRadius: 3,
        pointHoverRadius: 3,
        lineTension: 0,
        fill: false,
        borderWidth: 3,
        data: [0, 0, 0, 0, 0, 0, 0]
        }],
        color: '#6bd098',
        options: {
        tooltips: tooltipOptions,
        scales: {
            yAxes: [{

            ticks: {
                fontColor: "#9f9f9f",
                beginAtZero: false,
                maxTicksLimit: 5,
            },
            gridLines: {
                drawBorder: false,
                borderDash: [8, 5],
                zeroLineColor: "transparent",
                color: '#9f9f9f'
            }

            }],

            xAxes: [{
            barPercentage: 1.6,
            gridLines: {
                drawBorder: false,
                borderDash: [8, 5],
                color: '#9f9f9f',
                zeroLineColor: "transparent"
            },
            ticks: {
                padding: 20,
                fontColor: "#9f9f9f"
            }
            }]
        }
        }
        },
        statusChart: {
            labels: [],
            datasets: [
                {
                label: "Finalizados",
                borderColor: '#fcc468',
                fill: true,
                backgroundColor: '#fcc468',
                hoverBorderColor: '#fcc468',
                borderWidth: 8,
                data: [],
                },
                {
                label: "En trámite",
                borderColor: '#4cbdd7',
                fill: true,
                backgroundColor: '#4cbdd7',
                hoverBorderColor: '#4cbdd7',
                borderWidth: 8,
                data: [],
                }
            ],
            options: {
                tooltips: tooltipOptions
            }
        },
        averageChart: {
            labels: [],
            datasets: [
                {
                label: "Minutos en promedio",
                borderColor: '#fcc468',
                fill: true,
                backgroundColor: '#fcc468',
                hoverBorderColor: '#fcc468',
                borderWidth: 8,
                data: [],
                },
            ],
            options: {
                tooltips: tooltipOptions
            }
        },
        activityChart: {
            labels: [],
            datasets: [
                {
                label: "Comercio",
                borderColor: '#fcc468',
                fill: true,
                backgroundColor: '#fcc468',
                hoverBorderColor: '#fcc468',
                borderWidth: 8,
                data: [],
                },
                {
                label: "Producción",
                borderColor: '#4cbdd7',
                fill: true,
                backgroundColor: '#4cbdd7',
                hoverBorderColor: '#4cbdd7',
                borderWidth: 8,
                data: [],
                },
                {
                label: "Servicios",
                borderColor: '#4d56d7',
                fill: true,
                backgroundColor: '#4d56d7',
                hoverBorderColor: '#4d56d7',
                borderWidth: 8,
                data: [],
                }
            ],
            options: {
                tooltips: tooltipOptions
            }
        },
        }
        },
        filters: {
            reportTimeMethod (reportTime) {
                moment.locale('es');
                if (reportTime != null) {
                    return moment(reportTime).fromNow()
                }
                else {
                    return 'No hay reportes actualmente'
                }
            },
        },
        methods: {
            verifySession () {
                var vm = this;
                return new Promise(function(resolve, reject) {
                    var accessTokenDecoded = new SecureLS({encodingType: 'aes'});
                    var myToken = accessTokenDecoded.get('adminAccessToken').data;
                    axios.defaults.headers.common["Authorization"] = 'Jwt '+myToken;
                    var refreshToken = accessTokenDecoded.get('adminRefreshToken').data;
                    vm.$apollo.mutate({
                        mutation: VERIFY_TOKEN,
                        variables : {
                            input : {
                                token: myToken,
                            }
                        }
                    }).then((data) => {
                        resolve(true);
                    }).catch((error) => {
                        if(error.graphQLErrors.length > 0)
                        {
                            if (error.graphQLErrors[0].message == "Signature has expired") {
                                vm.$apollo.mutate({
                                    mutation: REFRESH_TOKEN,
                                    variables : {
                                        input : {
                                        refreshToken: refreshToken,
                                        }
                                    }
                                }).then((data) => {
                                    vm.$store.dispatch('updateToken',data.data.refreshToken).then(()=>{
                                        resolve(true);
                                    });
                                }).catch((error) => {
                                    resolve(false);
                                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                                });
                            }
                        }
                        else {
                            resolve(false);
                            vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                        }
                    });
                });
            },
            async downloadXLS() {
                var vm = this;
                vm.isSending = true;
                if (vm.model.startdate == '' || vm.model.enddate == '') {
                    vm.showNotificationError('El rango de fechas es obligatorio');
                    return
                }
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        // url: process.env.VUE_APP_BASE_URL+'xls/assessments/2020-06-01/2020-06-30',
                        url: process.env.VUE_APP_BASE_URL+'xls/assessments/'+moment(vm.model.startdate).format('YYYY-MM-DD')+'/'+moment(vm.model.enddate).format('YYYY-MM-DD'),
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'reporte.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        vm.isSending = false;
                        // let blob = new Blob([response.data], { type: 'application/pdf' })
                        // let url = window.URL.createObjectURL(blob)
                        // var myWindow = window.open(url)
                        // if (myWindow == null) {
                        //     vm.showCharacterAnalysis = false;
                        //     vm.showNotificationError('Debes autorizar las ventanas emergentes para este sitio');
                        // }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, inténtalo de nuevo');
                        console.info(error);
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            resetOffice () {
                this.model.office = '';
                this.model.user = '';
            },
            resetUser () {
                this.model.user = '';
            },
            setMonthlyReport (monthlyReport) {
                this.viewReports = true;
                var labels = [];
                var finishedData = [];
                var inProcessData = [];
                for (let i=0; i<monthlyReport.monthlyHistorical.length;i++) {
                    labels.push(monthlyReport.monthlyHistorical[i].monthName);
                    finishedData.push(monthlyReport.monthlyHistorical[i].finished)
                    inProcessData.push(monthlyReport.monthlyHistorical[i].inProcess)
                }
                this.stockChart.labels =  labels;
                this.stockChart.datasets[0].data = finishedData;
                this.stockChart.datasets[1].data = inProcessData;
            },
            // Retorna un número aleatorio entre min (incluido) y max (excluido)
            getRandomArbitrary(min, max) {
                return Math.random() * (max - min) + min;
            },
            /***
             * Función para setear en la tabla los datos que llegan desde las Regionales
             */
            setRegionalsReportsFullData(regionalsReports) {
                this.statusChart.labels = [];
                this.statusChart.datasets[0].data = [];
                this.statusChart.datasets[1].data = [];
                this.averageChart.labels = [];
                this.averageChart.datasets[0].data = [];
                this.activityChart.labels = [];
                this.activityChart.datasets[0].data = [];
                this.activityChart.datasets[1].data = [];
                this.activityChart.datasets[2].data = [];
                for (let i=0;i<regionalsReports.edges.length;i++) {
                    this.statusChart.labels.push(regionalsReports.edges[i].node.name);
                    this.statusChart.datasets[0].data.push(regionalsReports.edges[i].node.finished);
                    this.statusChart.datasets[1].data.push(regionalsReports.edges[i].node.inProcess);
                    this.averageChart.labels.push(regionalsReports.edges[i].node.name);
                    if(regionalsReports.edges[i].node.finished != 0) {
                        this.averageChart.datasets[0].data.push(regionalsReports.edges[i].node.averageTime);
                    }
                    else {
                        this.averageChart.datasets[0].data.push(0);
                    }
                    this.activityChart.labels.push(regionalsReports.edges[i].node.name);
                    this.activityChart.datasets[0].data.push(regionalsReports.edges[i].node.commerceActivityCount);
                    this.activityChart.datasets[1].data.push(regionalsReports.edges[i].node.productionActivityCount);
                    this.activityChart.datasets[2].data.push(regionalsReports.edges[i].node.servicesActivityCount);
                }
                this.viewReports = true;
            },
            /***
             * Función para setear en la tabla los datos que llegan desde las Regionales
             */
            setRegionalReportsFullData(regionalReports) {
                this.statusChart.labels = [];
                this.statusChart.datasets[0].data = [];
                this.statusChart.datasets[1].data = [];
                this.averageChart.labels = [];
                this.averageChart.datasets[0].data = [];
                this.activityChart.labels = [];
                this.activityChart.datasets[0].data = [];
                this.activityChart.datasets[1].data = [];
                this.activityChart.datasets[2].data = [];
                for (let i=0;i<regionalReports.officeSet.edges.length;i++) {
                    this.statusChart.labels.push(regionalReports.officeSet.edges[i].node.name);
                    this.statusChart.datasets[0].data.push(regionalReports.officeSet.edges[i].node.finished);
                    this.statusChart.datasets[1].data.push(regionalReports.officeSet.edges[i].node.inProcess);
                    this.averageChart.labels.push(regionalReports.officeSet.edges[i].node.name);
                    if(regionalReports.officeSet.edges[i].node.finished != 0) {
                        this.averageChart.datasets[0].data.push(regionalReports.officeSet.edges[i].node.averageTime);
                    }
                    else {
                        this.averageChart.datasets[0].data.push(0);
                    }
                    this.activityChart.labels.push(regionalReports.officeSet.edges[i].node.name);
                    this.activityChart.datasets[0].data.push(regionalReports.officeSet.edges[i].node.commerceActivityCount);
                    this.activityChart.datasets[1].data.push(regionalReports.officeSet.edges[i].node.productionActivityCount);
                    this.activityChart.datasets[2].data.push(regionalReports.officeSet.edges[i].node.servicesActivityCount);
                }
                this.viewReports = true;
            },
            /***
             * Función para setear en la tabla los datos que llegan desde las Regionales
             */
            setOfficeReportsFullData(officeReports) {
                this.statusChart.labels = [];
                this.statusChart.datasets[0].data = [];
                this.statusChart.datasets[1].data = [];
                this.averageChart.labels = [];
                this.averageChart.datasets[0].data = [];
                this.activityChart.labels = [];
                this.activityChart.datasets[0].data = [];
                this.activityChart.datasets[1].data = [];
                this.activityChart.datasets[2].data = [];
                for (let i=0;i<officeReports.creditanalystSet.edges.length;i++) {
                    this.statusChart.labels.push(officeReports.creditanalystSet.edges[i].node.user.name);
                    this.statusChart.datasets[0].data.push(officeReports.creditanalystSet.edges[i].node.finished);
                    this.statusChart.datasets[1].data.push(officeReports.creditanalystSet.edges[i].node.inProcess);
                    this.averageChart.labels.push(officeReports.creditanalystSet.edges[i].node.user.name);
                    if(officeReports.creditanalystSet.edges[i].node.finished != 0) {
                        this.averageChart.datasets[0].data.push(officeReports.creditanalystSet.edges[i].node.averageTime);
                    }
                    else {
                        this.averageChart.datasets[0].data.push(0);
                    }
                    this.activityChart.labels.push(officeReports.creditanalystSet.edges[i].node.user.name);
                    this.activityChart.datasets[0].data.push(officeReports.creditanalystSet.edges[i].node.commerceActivityCount);
                    this.activityChart.datasets[1].data.push(officeReports.creditanalystSet.edges[i].node.productionActivityCount);
                    this.activityChart.datasets[2].data.push(officeReports.creditanalystSet.edges[i].node.servicesActivityCount);
                }
                this.viewReports = true;
            },
            /***
             * Función para setear en la tabla los datos que llegan desde las evalaciones
             */
            setFinancialAssessments(assessmentsReport){
                var vm = this;
                vm.viewReports = true;
                vm.reportTime = moment();
                vm.finishedAssessmentsCount = assessmentsReport.finishedAssessmentsCount.toString();
                vm.inProcessAssessmentsCount = assessmentsReport.inProcessAssessmentsCount.toString();
            },
            /***
             * Función para setear en la tabla los datos que llegan desde la Regional
             */
            setRegionals(regionals){
                var vm = this;
                for(let i=0;i<regionals.edges.length;i++)
                {
                    vm.pushRegionalsData(regionals.edges[i].node);
                }
                vm.orderRegionalsData();
            },
            /***
             * Función para setear en la tabla los datos que llegan desde la oficina
             */
            setOffices(offices){
                var vm = this;
                for(let i=0;i<offices.edges.length;i++)
                {
                    vm.pushOfficesData(offices.edges[i].node);
                }
                vm.orderOfficesData();
            },
            /***
            * Función para setear en la tabla los datos que llegan desde la Regional
            */
            setActivityTypes(activityTypes){
            var vm = this;
            for(let i=0;i<activityTypes.edges.length;i++)
            {
                vm.pushData(activityTypes.edges[i].node);
            }
            vm.orderData();
            },
            /***
             * Función para setear en la tabla los datos que llegan desde el usuario
             */
            setUsers(users){
                // console.info(users);
                var vm = this;
                for(let i=0;i<users.edges.length;i++)
                {
                    if (users.edges[i].node.creditanalyst != null) {
                        vm.pushUsersData(users.edges[i].node);
                    }
                }
                vm.orderUsersData();
            },
            /***
            * Función que valida si se está enviando o cargando datos
            */
            handleLoading(){
            if(isLoading == true || isSending == true){
                return true
            }
            else{
                return false
            }
            },
            /***
            * Función que se dispara cuando se da clic en Agregar tipo de actividad
            */
            handleAdd (){
                var vm = this;
                let promise = new Promise(function(resolve, reject) {
                vm.resetForm();
                vm.formName = 'Agregar tipo de actividad';
                vm.setVisibleForm(true,false)//Asignamos las variables de visualización del formulario
                vm.errors.clear();//Borramos las validaciones en los campos.
                resolve();
                }).then(function(resolve){
                vm.focusFirstField();
                });

            },
            /***
            * Función que se dispara cuando se da clic en Editar tipo de actividad
            */
            handleEdit (index, row) {
                var vm = this;
                vm.rowEdit = row;
                vm.setVisibleForm(false,true)//Asignamos las variables de visualización del formulario
            },
            /***
            * Función que se dispara cuando se da clic en Desactivar tipo de actividad
            */
            handleDeactivate (index, row) {
                var vm = this;
                swal({
                    title: '¿Estás seguro?',
                    text: 'Si aceptas, desactivarás el tipo de actividad seleccionada',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, desactivar',
                    cancelButtonText: 'No, cancelar',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                }).then(() => {
                    this.isSending = true;
                    var id = vm.idDecode(row.id);
                    this.$apollo.mutate({
                        mutation: CREATE_ACTIVITY_TYPE,
                        variables : {
                            input :  {
                                    id : id,
                                    code : row.code,
                                    name : row.name,
                                    isActive : false
                                }
                        }
                    }).then((data) => {
                        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
                        if (indexToDelete >= 0) {
                        this.tableData.splice(indexToDelete, 1)
                        }
                        this.pushData(data.data.activityType.activityType);
                        this.orderData();
                        this.isSending = false;
                        swal({
                        title: '¡Desactivado!',
                        text: 'El tipo de actividad seleccionada ha sido desactivada',
                        type: 'success',
                        confirmButtonClass: 'btn btn-success btn-fill',
                        buttonsStyling: false
                        }).then(() => {
                            vm.reloadData();
                        },function (dismiss){
                            vm.reloadData();
                        });
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error, inténtalo de nuevo');
                    });

                }, function (dismiss) {
                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    swal({
                        title: 'Cancelado',
                        text: 'El tipo de actividad no ha sido desactivado',
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                    })
                    })
            },
            /***
            * Función que se dispara cuando se da clic en Activar tipo de actividad
            */
            handleActivate (index, row) {
                var vm = this;
                swal({
                    title: '¿Estás seguro?',
                    text: 'Si aceptas, activarás el tipo de actividad seleccionada',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, activar',
                    cancelButtonText: 'No, cancelar',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                }).then(() => {
                    this.isSending = true;
                    var id = vm.idDecode(row.id);
                    this.$apollo.mutate({
                        mutation: CREATE_ACTIVITY_TYPE,
                        variables : {
                            input :  {
                                    id : id,
                                    code : row.code,
                                    name : row.name,
                                    isActive : true
                                }
                        }
                    }).then((data) => {
                        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
                        if (indexToDelete >= 0) {
                        this.tableData.splice(indexToDelete, 1)
                        }
                        this.pushData(data.data.activityType.activityType);
                        this.orderData();
                        this.isSending = false;
                        swal({
                        title: '¡Activada!',
                        text: 'El tipo de actividad seleccionada ha sido activado',
                        type: 'success',
                        confirmButtonClass: 'btn btn-success btn-fill',
                        buttonsStyling: false
                        }).then(() => {
                            vm.reloadData();
                        },function (dismiss){
                            vm.reloadData();
                        });
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error, inténtalo de nuevo');
                    });

                }, function (dismiss) {
                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    swal({
                        title: 'Cancelado',
                        text: 'El tipo de actividad no ha sido activado',
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                    })
                    })
            },
            /**
            * Función que pone el foco en el campo de code
            */
            focusFirstField(){
                var vm = this;
                if(vm.addActivityType)
                {
                    this.$refs.code.$el.children[0].focus();//Asignamos focus en el campo
                }
                else if(vm.editActivityType)
                {
                    this.$refs.name.$el.children[0].focus();//Asignamos focus en el campo
                }
            },
            /**
            * Función para asignar el true o false a las opciones de agregar y editar tipos de actividad
            */
            setVisibleForm(add,edit)
            {
            this.addActivityType = add;
            this.editActivityType = edit;
            },
            /***
            * Función que resetea el formulario
            */
            resetForm(){
                this.model.id = '';
                this.model.code = '';
                this.model.name = '';
                this.model.user = '';
                this.model.regional = '';
                this.model.office = '';
                this.model.isActive = true;
            },
            /***
            * Función que cancela la creación/edición de usuarios y resetea los campos
            */
            cancelForm(){
                this.skipRegionalsReports = true;
                this.skipRegionalReports = true;
                this.skipOfficeReports = true;
                this.viewReports = false;
                this.inProcessAssessmentsCount = '0';
                this.finishedAssessmentsCount = '0';
                this.model.startdate = '';
                this.model.enddate = '';
                this.model.user = '';
                this.model.regional = '';
                this.model.office = '';
                this.analyst_fetch= null;
                this.office_fetch= null;
                this.regional_fetch= null;
                this.startdate_fetch= null;
                this.enddate_fetch= null;
                this.errors.clear();
                this.model.startdate = moment().startOf('isoWeek').format();
                this.model.enddate = moment().endOf('isoWeek').format();
                this.startdate_fetch = this.momentOutput(moment().startOf('isoWeek').format());
                this.enddate_fetch = this.momentOutput(moment().endOf('isoWeek').format());
                this.created_at_fetch = this.momentOutput2(moment().startOf('isoWeek').format());
                this.created_at_end_fetch = this.momentOutput2(moment().endOf('isoWeek').format());
                window.scrollTo(0,0);
            },
            /***
            * Función que permite visualizar los errores en cada campo del input
            */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /***
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
            */
            onSuccess(message){
                swal({
                    title: `¡Correcto!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    type: 'success'
                });
            },
            /***
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
            */
            onError(message){
                swal({
                    title: `¡Alerta!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger btn-fill',
                    type: 'error'
                });
            },
            /***
            * Función que oculta el formulario de creación/edición una vez realizado un envío de datos al servidor
            */
            reloadData(){
                var vm = this;
                vm.resetForm();
                vm.setVisibleForm(false,false)//Asignamos las variables de visualización del formulario
            },
            /***
            * Función para agregar un objeto al arreglo de datos
            */
            pushData(node){
                var vm = this;
                vm.tableData.push({
                id: node.id,
                code: node.code,
                name: node.name,
                isActive: node.isActive,
                });
            },
            /***
            * Función para agregar un objeto al arreglo de datos
            */
            pushUsersData(node){
                var vm = this;
                vm.users_array.push({
                    id: node.id,
                    name: node.name,
                    surname: node.surname,
                    username: node.username,
                    office: node.creditanalyst.office.id
                });
            },
            /***
            * Función para agregar un objeto al arreglo de datos de regionales
            */
            pushRegionalsData(node){
                var vm = this;
                vm.regionals_array.push({
                    id: node.id,
                    code: node.code,
                    name: node.name
                });
            },
            /***
            * Función para agregar un objeto al arreglo de datos de oficinas
            */
            pushOfficesData(node){
                var vm = this;
                vm.offices_array.push({
                    id: node.id,
                    code: node.code,
                    name: node.name,
                    regional: node.regional.id
                });
            },
            /***
            * Función para ordenar el arreglo de datos
            */
            orderData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.tableData, o => o.name);
                // vm.tableData = myOrderedArray;
                vm.tableData = vm.assessments;
            },
            /***
            * Función para ordenar el arreglo de datos de usuarios
            */
            orderUsersData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.users_array, o => o.name);
                vm.users_array = myOrderedArray;
            },
            orderRegionalsData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.regionals_array, o => o.name);
                vm.regionals_array = myOrderedArray;
            },
            /***
            * Función para ordenar el arreglo de datos de regionales
            */
            orderOfficesData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.offices_array, o => o.name);
                vm.offices_array = myOrderedArray;
            },
            /***
            * Función para decodificar el ID en base 64
            */
            idDecode(id){
                let id_decoded = atob(id);
                return id_decoded.split(":")[1];
            },
            /***
            * Función para mostrar un mensaje de error
            */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * Función para dar formato de hora a los datos de salida
             */
            momentOutput(date) {
                moment.locale('es');
                return moment(date).format('YYYY-MM-DD');
            },
            /**
             * Función para dar formato de hora a los datos de salida
             */
            momentOutput2(date) {
                moment.locale('es');
                return moment(date).format();
            },
            /***
            * Función para validar el formulario de edición y creación que se envía
            */
            validate () {
              this.$validator.validateAll().then(isValid => {
                  if(isValid){
                      // this.$emit('on-submit', this.registerForm, isValid)
                      var vm = this;
                      vm.tableData = []
                      if((vm.model.startdate != '' && vm.model.enddate == '') || (vm.model.startdate == '' && vm.model.enddate != '')){
                          vm.onError('Las dos fechas son obligatorias');
                          return
                      }
                      if(vm.model.startdate > vm.model.enddate){
                          vm.onError('La fecha de inicio no puede ser mayor a la fecha de fin');
                          return
                      }

                      // Validar que la diferencia entre fechas no supere 1 día
                      if(vm.model.startdate != '' && vm.model.enddate != '') {
                          const startMoment = moment(vm.model.startdate);
                          const endMoment = moment(vm.model.enddate);

                          // Calcular la diferencia en días
                          const diffDays = endMoment.diff(startMoment, 'days');

                          if(diffDays > 1) {
                              vm.onError('La diferencia entre las fechas no puede superar 1 día');
                              return
                          }
                      }

                      if (vm.model.startdate != '') {
                          vm.created_at_fetch = vm.momentOutput2(vm.model.startdate);
                          vm.startdate_fetch = vm.momentOutput(vm.model.startdate);
                          vm.created_at_end_fetch = vm.momentOutput2(vm.model.enddate);
                          vm.enddate_fetch = vm.momentOutput(vm.model.enddate);
                      }
                      if(vm.model.regional == '') {
                          //vm.skipRegionalsReports = false;
                          //vm.$apollo.queries.regionalsReports.refetch();
                          vm.onError('Debe seleccionar una regional');
                          return
                      }
                      if (vm.model.regional != '' && vm.model.office == '') {
                          // vm.regional_fetch = vm.idDecode(vm.model.regional);
                          vm.regional_fetch = vm.model.regional;
                          vm.skipRegionalReports = false;
                          vm.$apollo.queries.regionalReports.refetch()
                      }
                      if (vm.model.regional != '' && vm.model.office != '') {
                          vm.office_fetch = vm.model.office;
                          vm.skipOfficeReports = false;
                          vm.$apollo.queries.officeReports.refetch()
                      }
                      // if (vm.model.user != '') {
                      //     vm.analyst_fetch = vm.idDecode(vm.model.user);
                      // }
                  }
              })
          }
        },
        created() {
            this.interval = setInterval(() => this.$forceUpdate(), 1000);
        },
        beforeDestroy() {
            clearInterval(this.interval);
        },
        beforeMount() {
            moment.locale('es');
            this.model.startdate = moment().startOf('isoWeek').format();
            this.model.enddate = moment().endOf('isoWeek').format();
            this.startdate_fetch = this.momentOutput(moment().startOf('isoWeek').format());
            this.enddate_fetch = this.momentOutput(moment().endOf('isoWeek').format());
            this.created_at_fetch = this.momentOutput2(moment().startOf('isoWeek').format());
            this.created_at_end_fetch = this.momentOutput2(moment().endOf('isoWeek').format());
        },
        mounted() {

            // this.test();
            // alert(this.$window.csrf_token);
        }
    }
    </script>
    <style lang="scss">
    .el-table .td-actions{
    button.btn {
        margin-right: 5px;
    }
    }
    // Función para centrar la imagen del Empty State
    .no_data_center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        max-width: 500px;
    }
    // Estilos para poder centrar el título de la actividad
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>

